import { twMerge } from 'tailwind-merge';

const Container = ({ className = '', children }) => (
  <div className={twMerge('mx-auto w-full max-w-[82rem] px-5 md:px-8', className)}>
    {children}
  </div>
);

export default Container;
